// react
import { useContext } from "react";
import _ from "lodash";

// context
import ProductContext from "../../context/ProductContext";

// component
import LoginLink from "../loginLink/LoginLink";

// styles
import "./AvailabilitySection.styles.scss";

const AvailabilityTableRow = ({
  Location,
  CommittedQty,
  UOM,
}: {
  Location: any;
  CommittedQty: any;
  UOM: any;
}) => (
  <tr>
    <td>{Location}</td>
    <td>{CommittedQty && Math.round(CommittedQty)}</td>
    <td>{UOM === "EA" ? "Each" : UOM}</td>
  </tr>
);

const AvailabilityList = () => {
  const context: any = useContext(ProductContext);

  const {
    productState: {
      IsUserLoggedIn,
      AvailableInventoryList,
      InventoryStatusMessage,
      InventoryStatusCode,
    },
  }: {
    productState: {
      IsUserLoggedIn: boolean;
      AvailableInventoryList: any[];
      InventoryStatusMessage: string;
      InventoryStatusCode: number;
      User: any;
    };
  } = context;

  const shouldShowInventoryStatusMessage = () => {
    if (!AvailableInventoryList?.length) {
      return true;
    }

    const inventoryTotalQty = AvailableInventoryList?.reduce(
      (total: number, inventoryItem: any) => {
        return (total += Number(inventoryItem.CommittedQty));
      },
      0,
    );

    return InventoryStatusCode === 503 || inventoryTotalQty === 0;
  };

  return (
    <>
      {shouldShowInventoryStatusMessage() ? (
        <p
          className="availability_message"
          dangerouslySetInnerHTML={{
            __html: InventoryStatusMessage ?? "",
          }}
        ></p>
      ) : (
        <>
          <table>
            <thead>
              <tr>
                <th scope="col">Stock Location</th>
                <th scope="col">Qty Available</th>
                <th scope="col">Unit of Measure</th>
              </tr>
            </thead>
            <tbody>
              {IsUserLoggedIn && (
                <>
                  {_.orderBy(
                    AvailableInventoryList,
                    ["CommittedQty"],
                    ["desc"],
                  ).map((AvailableInventory: any, index: number) => (
                    <AvailabilityTableRow
                      key={`availability-${index}`}
                      {...AvailableInventory}
                    />
                  ))}
                </>
              )}
            </tbody>
          </table>
          {!IsUserLoggedIn && (
            <div style={{ margin: "26px 0" }}>
              <LoginLink customMessage={"availability"} />
            </div>
          )}
        </>
      )}
    </>
  );
};

interface SAPLeadTimeProps {
  OutlineColor?: string;
  IconColor?: string;
  Icon?: string;
  SAPDelivaryDate?: string;
  SAPStatusCode?: string;
  Message?: string;
}

export const LeadTimeSection = () => {
  const context: any = useContext(ProductContext);
  const {
    productState: { SAPLeadTime },
  }: {
    productState: {
      SAPLeadTime: SAPLeadTimeProps;
    };
  } = context;

  const delivaryDateHandler = () =>
    SAPLeadTime &&
    SAPLeadTime.SAPDelivaryDate &&
    SAPLeadTime.SAPStatusCode !== "0" &&
    SAPLeadTime.SAPStatusCode !== "99" &&
    SAPLeadTime.SAPStatusCode !== "98" &&
    SAPLeadTime.SAPStatusCode !== "86" ? (
      <b>{` ${SAPLeadTime.SAPStatusCode} ${
        SAPLeadTime.SAPStatusCode === "1" ? " Day - " : " Days - "
      } ${SAPLeadTime.SAPDelivaryDate}`}</b>
    ) : null;

  if (SAPLeadTime != null) {
    return (
      <>
        {SAPLeadTime ? (
          <div className="_availability_component_leadtime">
            <div style={{ borderColor: SAPLeadTime.OutlineColor }}>
              <div
                className="material-icons"
                style={{ color: SAPLeadTime.IconColor }}
              >
                {SAPLeadTime.Icon}
              </div>
              <div>
                <>
                  <span
                    className="_availability_component_leadtime_text"
                    dangerouslySetInnerHTML={{
                      __html: SAPLeadTime.Message + " ",
                    }}
                  ></span>
                  <span> {delivaryDateHandler()}</span>
                </>
              </div>
            </div>
          </div>
        ) : null}
      </>
    );
  } else {
    return null;
  }
};

const AvailabilitySection = () => (
  <div className="_availability_component">
    <div className="_availability_component_content">
      <div className="_availability_component_content_table">
        <AvailabilityList />
      </div>
    </div>
  </div>
);
export default AvailabilitySection;
